$(function () {
    $.fn.scrollspySideNav = function () {
        if (!$(this).length) { return false; };
        var mainHeadHeight = $('.main-head').height();

        $('body').scrollspy({
            target: '#scrollspy-side-nav',
            offset: mainHeadHeight + 10
        });
    };

    $("#scrollspy-side-nav").scrollspySideNav();
});
